<div class="login bg-transparent">
  <div class="content">
    <div class="leftcontent">
      <nav class="Headercontainer mx-[60px]">
        <div class="authHeader grid gap-8 place-content-center">
          <div class="logo w-[300px] overflow-hidden scale-125">
            <img
              [src]="logoimage2"
              alt="Loginlogo"
              [width]="350"
              [height]="200"
              class="font-bold flex justify-center items-center text-primary" />
          </div>

          <div class="text-xs">
            <span>
              <!-- Login with -->
              <!-- <a
                class="bg-clip-text to-88% cursor-pointer hover:underline"
                [routerLink]="'/auth/sign-up'">
                Sign up
              </a> -->
            </span>
          </div>
        </div>
      </nav>
      <div class="login_container">
        <div class="container-wrapper">
          <div class="flex flex-col items-center justify-between mt-6">
            <div class="flex flex-col items-center justify-center">
              <div x-data="{ openTab: 1 }">
                <div class="w-[399px]">
                  <div
                    x-show="openTab === 1"
                    class="transition-all duration-300 bg-transparent rounded-lg">
                    <app-login></app-login>
                  </div>
                </div>
              </div>
              <a
                class="first-btn text-white bg-primary mt-5 w-[399px] items-start"
                href="https://writemed.ai/contact-us/"
                >Request Signup</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
